import { useEffect, useState } from 'react';

const useElapsedSeconds = (active) => {
  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    setElapsed(0);
    if (!active) return undefined;

    const interval = setInterval(() => {
      setElapsed((seconds) => seconds + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [active]);

  return elapsed;
};

export default useElapsedSeconds;
